(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[241],{

/***/ 672:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/[jobsSlug]",
      function () {
        return __webpack_require__(6924);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5944);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2962);
/* harmony import */ var _public_android_chrome_512x512_png__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8393);
/* harmony import */ var utils_convert__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4393);




const Jobs = (param)=>{
    let { SEO , Layout  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25;
    const FRONTEND_DOMAIN = "https://www-bo.belga.be" || 0;
    const BACKEND_DOMAIN = "https://www-bo.belga.be" || 0;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
        children: [
            SEO && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(next_seo__WEBPACK_IMPORTED_MODULE_0__/* .NextSeo */ .PB, {
                title: SEO.title,
                description: SEO.description,
                openGraph: {
                    title: (ref = SEO.openGraph) === null || ref === void 0 ? void 0 : ref.title,
                    description: (ref1 = SEO.openGraph) === null || ref1 === void 0 ? void 0 : ref1.description,
                    url: "".concat("https://www-bo.belga.be").concat((ref2 = SEO.openGraph) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.images) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.attributes) === null || ref5 === void 0 ? void 0 : ref5.url),
                    siteName: (ref6 = SEO.openGraph) === null || ref6 === void 0 ? void 0 : ref6.siteName,
                    type: (ref7 = SEO.openGraph) === null || ref7 === void 0 ? void 0 : ref7.type,
                    images: [
                        {
                            url: (SEO === null || SEO === void 0 ? void 0 : (ref8 = SEO.openGraph) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.images) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.data) === null || ref10 === void 0 ? void 0 : ref10.attributes.url) ? "".concat(BACKEND_DOMAIN + (SEO === null || SEO === void 0 ? void 0 : (ref11 = SEO.openGraph) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.images) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.data) === null || ref13 === void 0 ? void 0 : ref13.attributes.url)) : _public_android_chrome_512x512_png__WEBPACK_IMPORTED_MODULE_1__/* ["default"].src */ .Z.src,
                            width: (SEO === null || SEO === void 0 ? void 0 : (ref14 = SEO.openGraph) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.images) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.data) === null || ref16 === void 0 ? void 0 : ref16.attributes.width) || _public_android_chrome_512x512_png__WEBPACK_IMPORTED_MODULE_1__/* ["default"].width */ .Z.width,
                            height: (SEO === null || SEO === void 0 ? void 0 : (ref17 = SEO.openGraph) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.images) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.data) === null || ref19 === void 0 ? void 0 : ref19.attributes.height) || _public_android_chrome_512x512_png__WEBPACK_IMPORTED_MODULE_1__/* ["default"].height */ .Z.height,
                            alt: (SEO === null || SEO === void 0 ? void 0 : (ref20 = SEO.openGraph) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.images) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.data) === null || ref22 === void 0 ? void 0 : ref22.attributes.alternativeText) || "Belga.be",
                            type: (SEO === null || SEO === void 0 ? void 0 : (ref23 = SEO.openGraph) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.images) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.data) === null || ref25 === void 0 ? void 0 : ref25.attributes.mime) || "image/png"
                        }, 
                    ]
                },
                canonical: SEO.canonical
            }),
            Layout && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(utils_convert__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                layout: Layout
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Jobs);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [868,393,774,888,179], function() { return __webpack_exec__(672); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);